(function () {
  function loadScript(url, callback) {
    var script = document.createElement("script");
    script.src = url;
    script.onload = callback;
    script.onerror = function () {
      console.error("360 viewer: failed to load script", url);
    };
    document.head.appendChild(script);
  }

  function waitForSpriteSpin(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 100) {
      console.error("360 viewer: SpriteSpin never loaded");
      return;
    }
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.spritespin) {
      callback();
    } else {
      setTimeout(function () {
        waitForSpriteSpin(callback, attempts + 1);
      }, 50);
    }
  }

  function init() {
    var btn = document.querySelector(".btn-360-toggle");
    var overlay = document.getElementById("product-360-overlay");
    var mainImage = document.querySelector(".main-image");
    var dataScript = document.getElementById("spin-frames-data");

    if (!btn || !overlay || !mainImage || !dataScript) {
      console.error("360 viewer: missing elements");
      return;
    }

    var frames = [];
    try {
      var parsed = JSON.parse(dataScript.textContent);
      if (Array.isArray(parsed)) {
        frames = parsed.map(function (item) {
          if (typeof item === "string") {
            return item.indexOf("//") === 0 ? "https:" + item : item;
          }
          var url = "";
          if (item.src) url = item.src;
          else if (item.url) url = item.url;
          else if (item.image && typeof item.image === "string") url = item.image;
          else if (item.image && item.image.src) url = item.image.src;
          else if (item.preview_image && item.preview_image.src) url = item.preview_image.src;
          if (url && url.indexOf("//") === 0) url = "https:" + url;
          return url || null;
        }).filter(Boolean);
      }
    } catch (e) {
      console.error("360 viewer: JSON.parse failed", e);
      return;
    }

    if (frames.length === 0) {
      console.error("360 viewer: no frames found");
      return;
    }

    console.log("360 viewer: ready with", frames.length, "frames");

    var active = false;
    var initialized = false;

    // Load jQuery first, then SpriteSpin
    loadScript(
      "https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js",
      function () {
        console.log("360 viewer: jQuery loaded");
        loadScript(
          "https://cdn.jsdelivr.net/npm/spritespin@4.1.0/release/spritespin.min.js",
          function () {
            console.log("360 viewer: SpriteSpin loaded");
          }
        );
      }
    );

    function renderSpin() {
      var container = document.getElementById("product-360");
      var w = container.offsetWidth;
      var h = container.offsetHeight;

  waitForSpriteSpin(function () {
    jQuery("#product-360").spritespin({
      source: frames,
      width: w,
      height: h,
      animate: false,
      frameTime: 60,
      sense: -1,
      responsive: true,
    });
  });
    }

    function initSpin() {
      renderSpin();
      initialized = true;
    }

    function openViewer() {
      overlay.style.display = "flex";
      btn.innerText = "✕ Back to Images";
      if (!initialized) {
        initSpin();
      } else {
        renderSpin();
      }
    }

    function closeViewer() {
      overlay.style.display = "none";
      btn.innerText = "360° View";
    }

    window.addEventListener("resize", function () {
      if (initialized && active) renderSpin();
    });

    btn.addEventListener("click", function () {
      active = !active;
      if (active) {
        openViewer();
      } else {
        closeViewer();
      }
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        active = false;
        closeViewer();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && active) {
        active = false;
        closeViewer();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();